export const ADDITIONAL_INFO_DATA = 'additionalInfoData';
export const INFO_DATA = 'infoData';
export const SERVICE_DATA = 'serviceData';
export const SETTINGS_DATA = 'settingsData';
export const ACCESS_RIGHTS_DATA = 'accessRightsData';
export const VISIT_HISTORY_DATA = 'visitHistoryData';

export const SERVICES_EXPORT_KEY = '1';
export const SERVICES_IMPORT_KEY = '2';
export const CATEGORY_ADDITION_KEY = '3';
export const SERVICE_ADDITION_KEY = '4';
export const SERVICES_IMPORT_TEMPLATE_KEY = '5';

export const LEAVE_TABS_MESSAGE =
  'В текущем разделе есть несохранённые данные. Уверены, что хотите покинуть страницу?';

export const SAVE_DATA_MESSAGE =
  'В текущем разделе есть несохранённые данные. Хотите сохранить данные перед уходом?';
export const CONFIRM_ACTION = 'Подтвердите действие';
export const CONFIRM = 'Подтвердить';
